import { render, staticRenderFns } from "./ClientListTable.vue?vue&type=template&id=0513b4a8"
import script from "./ClientListTable.vue?vue&type=script&lang=js"
export * from "./ClientListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports